import type { ApolloErrorInterop } from '@confluence/apollo-relay-interop/entry-points/ApolloErrorInterop.ts';

import { queryInterop } from '@confluence/apollo-relay-interop/entry-points/query.ts';
import { markErrorAsHandled } from '@confluence/graphql/entry-points/markErrorAsHandled.ts';
import { getMonitoringClient } from '@confluence/monitoring/entry-points/getMonitoringClient.ts';
import { Attribution } from '@confluence/error-boundary/entry-points/Attribution.ts';

import { LoomAuthTokenQuery } from './graphql/LoomAuthTokenQuery.graphql.ts';
import type { LoomAuthTokenQuery as LoomAuthTokenQueryType } from './graphql/__types__/LoomAuthTokenQuery.ts';
import { LoomAuthStateQuery } from './graphql/LoomAuthStateQuery.graphql.ts';
import type {
	LoomUserStatus,
	LoomAuthStateQuery as LoomAuthStateQueryType,
} from './graphql/__types__/LoomAuthStateQuery.ts';

type GetAuthTokenResponse = {
	recorderToken?: string;
	tokenError?: ApolloErrorInterop | Error | null;
};
export const getAuthToken = async (): Promise<GetAuthTokenResponse> => {
	try {
		const tokenQuery = await queryInterop<LoomAuthTokenQueryType>({
			query: LoomAuthTokenQuery,
			fetchPolicy: 'network-only',
		});
		return {
			recorderToken: tokenQuery.data.loomToken?.token,
		};
	} catch (e) {
		getMonitoringClient().submitError(e, {
			attribution: Attribution.CONTENT_TYPES,
		});
		markErrorAsHandled(e);
		return {
			tokenError: e,
		};
	}
};

export const getAuthState = async (): Promise<LoomUserStatus | undefined> => {
	try {
		const authStateQuery = await queryInterop<LoomAuthStateQueryType>({
			query: LoomAuthStateQuery,
		});

		return (authStateQuery.data.loomUserStatus as LoomUserStatus) ?? undefined;
	} catch (e) {
		getMonitoringClient().submitError(e, {
			attribution: Attribution.CONTENT_TYPES,
		});
		markErrorAsHandled(e);
		return undefined;
	}
};
